<script setup>
import {ref, onMounted, onUnmounted} from 'vue';
import poster from '@/assets/images/index/company.png'
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import createIntersectionObserver from "@/utils/intersectionObserver";
// https://obs-sm-store.obs.cn-east-3.myhuaweicloud.com:443/test/invoice/0_1692082863_CosgKjvr4f.jpg // video poster

const props = defineProps({
	videoResource: String
})

const videoRef = ref(null);
const isPlaying = ref(false);
const observer = ref(null)

const togglePlay = () => {
	if (isPlaying.value) {
		videoRef.value.pause();
	} else {
		videoRef.value.play();
	}
	isPlaying.value = !isPlaying.value;
}


onMounted(() => {
	observer.value = createIntersectionObserver((taget, isIntersecting) => {
		if (isIntersecting) {
			// videoRef.value.muted = true
			videoRef.value.play();
			isPlaying.value = true
		} else {
			videoRef.value.pause();
			isPlaying.value = false
		}
	})
	
	observer.value.observe(videoRef.value);
})

onUnmounted(() => {
	if (observer.value) {
		observer.value.unobserve(videoRef.value)
		observer.value.disconnect(videoRef.value)
	}
})
</script>

<template>
	<div class="video">
		<video
			ref="videoRef"
			:controls="isPlaying"
			preload
			:src="videoResource"
			:poster="poster"
			muted
		/>
		
		<div class="player" @click="togglePlay" v-if="!isPlaying">
			<SvgIcon name="player" class-name="player__icon" />
		</div>
	</div>
</template>

<style scoped lang="less">
.video {
	position: relative;
	
	>video {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.player {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		cursor: pointer;
		
		&__icon {
			width: 64px;
			height: 64px;
		}
	}
}

@media only screen and (max-width: 1024px) {
	.video {
		height: 500px;
		
		.player {
		
		}
	}
}

@media only screen and (max-width: 768px) {
	.video {
		height: 300px;
	}
}

@media only screen and (max-width: 535px) {
	.video {
		height: 200px;
	}
}
</style>